webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(57);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */]
}));

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HOME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SURVEY; });
/* unused harmony export UPDATE_NOTIFICATION */
/* unused harmony export CLEAR_COMPLETED_NOTIFICATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOWNLOAD_FILE; });
var HOME = 'HOME';
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';

var CASE = 'CASE';

var FETCH_DATA = 'FETCH_DATA';
var FETCH_FORM = 'FETCH_FORM';
var FETCH_SURVEY = 'FETCH_SURVEY';

var UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
var CLEAR_COMPLETED_NOTIFICATIONS = 'CLEAR_COMPLETED_NOTIFICATIONS';

var DOWNLOAD_FILE = 'DOWNLOAD_FILE';

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionIntro_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_604bb2ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionIntro_vue__ = __webpack_require__(81);
function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionIntro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_604bb2ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionIntro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(157);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = 'http://pmg-api.ai-qa.com';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.headers.common['Accept'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.headers.common['Content-Type'] = 'application/json';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token && request.headers.set('Authorization', 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token);

  next(function (response) {
    if (response.status === 401) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'logout' });
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CaseStudy__ = __webpack_require__(141);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    components: {
      home: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
    }
  }, {
    path: '/case-studies/:cs',
    name: 'cs',
    components: {
      cs: __WEBPACK_IMPORTED_MODULE_4__components_CaseStudy__["a" /* default */]
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(function (to, from, next) {
  next(to.meta.guarded && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token === '' ? { name: 'login' } : true);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7d3336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(74);
function injectStyle (ssrContext) {
  __webpack_require__(68)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7d3336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9433fa6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9433fa6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0ed6af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(139);
function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0ed6af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ks_vue_scrollmagic__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ks_vue_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ks_vue_scrollmagic__);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_ks_vue_scrollmagic___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_store__);


/* harmony default export */ __webpack_exports__["a"] = ({
  user: __WEBPACK_IMPORTED_MODULE_0_store___default.a.get('user') || {},
  token: __WEBPACK_IMPORTED_MODULE_0_store___default.a.get('token') || '',
  survey: [],
  form: [],
  currentCase: [],
  cases: [{
    slug: 'benefits_of_space_tour',
    title: 'Benefits of Space Tour',
    client: 'nasa',
    hero: '/static/images/case-studies/nasa-benefits/nasa-benefits-hero.jpg',
    thumb: '/static/images/case-studies/nasa-benefits/nasa-benefits_01.jpg',
    logo: '/static/svg/client-logos/NASA.svg',
    desc: '<p>Over 700 events and a decade of service for aerospace pioneer NASA</p>',
    body: '<p>The NASA Benefits of Space Tour ran from 1999 to 2009 with a major remodel of the trailer and the scope of the display in 2005. The goal of the tour was publicity and public outreach. Visiting schools and community events for a decade it attended nearly 500 events and reached just under one-million people. This tour easily achieved it’s goal of inspiring an entire generation to keep their eye’s on the skies.</p><p>For both iterations of the tour the trailer was split into two sections (front and back). From 1999 to 2005 the front of the trailer was a museum style presentation of about a dozen products and inventions that were a direct result of space exploration. This automated presentation would spotlight object around the room and narrate the history and uses for the individual product. In its second iteration the the front of the trailer was changed to a state of the art virtual mars atmosphere/experience with interactive floors and walls that would simulate gravity and conditions on the planet of Mars.</p><p>For both iterations of the tour the back half of the trailer had a large 80 seat Bose surround sound theater where short films showcasing space exploration and the International Space Station were shown. Crowds would be let into the trailer 80 at a time, and while the crowd outside waited they were entertained with trivia and prizes from NASA Volunteers. These volunteers ranged from scientists to astronauts and dramatically added to impact of the event on its target audience. In addition to the already out of this world experience; for a number of years the tour was one of only two places in the world where an actual moon rock was on display to the public making the NASA Benefit of Space Tour a truly unique endeavor.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_08.jpg'
    }, {
      id: 9,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_09.jpg'
    }, {
      id: 10,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_10.jpg'
    }, {
      id: 11,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_11.jpg'
    }, {
      id: 12,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_12.jpg'
    }, {
      id: 13,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_13.jpg'
    }, {
      id: 14,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_14.jpg'
    }, {
      id: 15,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_15.jpg'
    }, {
      id: 16,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_16.jpg'
    }, {
      id: 17,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_17.jpg'
    }, {
      id: 18,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_18.jpg'
    }, {
      id: 19,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_19.jpg'
    }, {
      id: 20,
      image: '/static/images/case-studies/nasa-benefits/nasa-benefits_20.jpg'
    }]
  }, {
    slug: 'da_vinci_surgical_robot',
    title: 'da Vinci Surgical Robot',
    client: 'intuitive surgical',
    hero: '/static/images/case-studies/is-da-vinci/is-da-vinci-hero.jpg',
    thumb: '/static/images/case-studies/is-da-vinci/is-da-vinci_01.jpg',
    logo: '/static/svg/client-logos/IntuitiveSurgical.svg',
    desc: '<p>4,200 events since 2004 for medical innovator Intuitive Surgical</p>',
    body: '<p>As PMG’s longest standing client Intuitive Surgical has seen first hand the value of experiential marketing. Starting in 2000 with the launch of the original Davinci Surgical System PMG operated a nationwide tour featuring a double slide-out trailer and specializing in surgeon education to help prepare the world for the new wave of robotic surgery.</p><p>Originally an educational tour, robotic surgery generated a _ of attention and in subsequent years the tour expanded dramatically. At first Intuitive had PMG add a second vehicle capable of delivering and setting up a pop-up trade show-show style demonstration. This could be installed and ready for use in a hospital, restaurant, or convention center within an hour or two of arrival. The program and new type of hospital sales demo was immensely successful and by 2015 had expanded to include a total of 14 concurrently operating tours.</p><p>The idea of a fleet of mobile sales demonstrations each attending up to 5 events per week has driven sales in an unprecedented way. The ability of PMG to manage such a large scale program while maintaining a professional and efficient tour schedule is why Intuitive surgical has chosen PMG as their tour management company for nearly 2 decades and are on-track to complete our 20,000th event for Intuitive Surgical early in 2019.</p><p>The tour has transformed to provide a live demonstration to all kinds of venues. It has attended thousands of hospitals and private venues for sales demonstrations. In addition the tour visits a number of special events and training summits. PMG has hosted Intuitive Surgical events at a variety of venues ranging from a local 5K for charity to The Superbowl. This innovative experiential marketing technique has changed the way sales, public outreach, and educational training is handled throughout the surgical industry.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/is-da-vinci/is-da-vinci_08.jpg'
    }]
  }, {
    slug: 'pristina_3d',
    title: 'Pristina 3D',
    client: 'general electric',
    hero: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d-hero.jpg',
    thumb: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_01.jpg',
    logo: '/static/svg/client-logos/GE.svg',
    desc: '<p>GE Healthcare gains $7 in sales for each $1 spent on PMG marketing tour</p>',
    body: '<p>In 2017 The Women\'s Health Division chose PMG to launch and promote their revolutionary 4D Prestina Mammography Machine and Sensory Suite. This tour was two part with a full sized trailer display encompassing the Pristina and a select group of other GE Healthcare related machinery. The other portion of the tour was a mobile trade show to take place inside of Hotels and convention centers at each stop. All properties and display items were transported aboard the trailer and unloaded and set-up inside the meeting space to provide a mobile trade-show focusing on GE products related to Mammography (software suits, SenoIris workstations, Invenia & Logiq Ultrasound, etc.). Each tour stop was attended by hospital administrators as well as doctors and surgeons interested in learning more about the technology on display. The tour was so successful that after the initial run subsequent events were and are currently being added to the schedule.</p><p>What made this tour so spectacular is the transformation of the inside of the trailer from a sterile lab environment into a spa setting. The design team at PMG worked closely with the staff of GE’s Women\'s Health to bring their vision to life. Attendee’s of the events are so blown away by the spa setting and atmosphere that was created that many requests have been made of the same design team to consult on their own imaging space.</p><p>The focus of the Pristina system was to take the discomfort and awkward lab feeling away from the associated medical procedures. GE’s science backs-up the correlation between a comfortable atmosphere and successful/effective screenings, and the trailer was designed around getting that point across.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_08.jpg'
    }, {
      id: 9,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_09.jpg'
    }, {
      id: 10,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_10.jpg'
    }, {
      id: 11,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_11.jpg'
    }, {
      id: 12,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_12.jpg'
    }, {
      id: 13,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_13.jpg'
    }, {
      id: 14,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_14.jpg'
    }, {
      id: 15,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_15.jpg'
    }, {
      id: 16,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_16.jpg'
    }, {
      id: 17,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_17.jpg'
    }, {
      id: 18,
      image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_18.jpg'
    }]
  }, {
    slug: 'embraer_erj190',
    title: 'Embraer ERJ190',
    client: 'embraer',
    hero: '/static/images/case-studies/embraer-ej190/embraer-ej190-hero.jpg',
    thumb: '/static/images/case-studies/embraer-ej190/embraer-ej190_06.jpg',
    logo: '/static/svg/client-logos/Embraer.svg',
    desc: '<p>50 marketing tour events in 24 months for aviation icon Embraer</p>',
    body: '<p>ERJ190 - In 2000 and 2001 Promotional Management Group teamed up with Embraer aircraft manufacturers to help launch and promote the sale of their new narrow-body medium-range twin-engine jet airliner. This was a truly unique tour aimed at bringing the experience of stepping onto a ERJ190 directly to Airlines throughout North America.</p><p>The tour consisted of a mockup of the fuselage built into a large mobile trailer at the heart of the display. This three vehicle tour was made up of the main Fuselage as well as a full sized motor coach specially designed to emulate the feeling of a high-end conference room. This mobile meeting space gave the client an area to negotiate and discuss the terms of sales on site. The third member of the tour was a “chase vehicle” containing large display pieces used to wow potential customers and illicit interest in the ERJ 190.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/embraer-ej190/embraer-ej190_07.jpg'
    }]
  }, {
    slug: 'innovation_delivered',
    title: 'Innovation: Delivered',
    client: 'covidien',
    hero: '/static/images/case-studies/covidien/covidien-hero.jpg',
    thumb: '/static/images/case-studies/covidien/covidien_01.jpg',
    logo: '/static/svg/client-logos/Covidien.svg',
    desc: '<p>120 events in 24 months for healthcare products provider Covidien</p>',
    body: '<p>In 2009 PMG was chosen to design, develop, manage and operate the Innovation: Delivered Tour. This tour featured hands-on workshops where surgeons, residents and hospital administrators were introduced and trained to use the new SILS Port Multiple Instrument Access Device. When parked the trailer expands into a clinical training area, conference room, and 5 independent operating room stations that accommodate 10 surgeons simultaneously. The goal of the tour was to visit hospitals, trade shows, and medical conferences “[Bringing] these crucial tools and opportunities directly to surgeons.” the tour was an immense success and would continue for 3 years to provide Covidien a valuable platform for everything from education to sales initiatives.</p><p>The demonstrations of the SILS Port system allowed a hands-on opportunity to generate interest in a system designed to dramatically reduce the risk and scarring associated with traditional surgery.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/covidien/covidien_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/covidien/covidien_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/covidien/covidien_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/covidien/covidien_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/covidien/covidien_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/covidien/covidien_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/covidien/covidien_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/covidien/covidien_08.jpg'
    }, {
      id: 9,
      image: '/static/images/case-studies/covidien/covidien_09.jpg'
    }, {
      id: 10,
      image: '/static/images/case-studies/covidien/covidien_10.jpg'
    }, {
      id: 11,
      image: '/static/images/case-studies/covidien/covidien_11.jpg'
    }, {
      id: 12,
      image: '/static/images/case-studies/covidien/covidien_12.jpg'
    }, {
      id: 13,
      image: '/static/images/case-studies/covidien/covidien_13.jpg'
    }, {
      id: 14,
      image: '/static/images/case-studies/covidien/covidien_14.jpg'
    }, {
      id: 15,
      image: '/static/images/case-studies/covidien/covidien_15.jpg'
    }]
  }, {
    slug: 'brand_revival_tour',
    title: 'Brand Revival Tour',
    client: 'indian motorcycles',
    hero: '/static/images/case-studies/im-brand-revival/im-brand-revival-hero.jpg',
    thumb: '/static/images/case-studies/im-brand-revival/im-brand-revival_01.jpg',
    logo: '/static/svg/client-logos/IndianMotorcycle.svg',
    desc: '<p>20 world tour events for iconic motorsports brand Indian Motorcycles</p>',
    body: '<p>In 2002 and 2003 Indian Motorcycle launched a new campaign to relaunch the formerly retired Indian Motorcycle stylings and label themselves as America’s First Motorcycle. The tour consisted of a Large Trailer and enclosed area where Indian antiques ranging from original signs to vintage motorcycles were on display to the public. The trailer contained a historical museum educating on the history of the brand, as well as a Museum containing rare original Indian Motorcycles. In addition the trailer had a dedicated retail store front where event specific gear was sold to eager fans. Each event partnered with local Indian Dealerships to provide a fleet of bikes for potential customers to test drive on-site.</p><p>This brand revival tour was focused on restoring brand recognition. The entire display centered around generating enthusiasm for Indian Motorcycles new line-up in direct competition with the other large names in the industry. The use of absolutely enormous logo placement and signage created an incredible pull on potential customers and attendance was substantially increased from the simple booths and tents used in prior years at the same events.</p><p>This was a three vehicle tour consisting of one large tractor trailer as the center of the display. An additional truck was used to transport the enormous signs and armory of attention grabbing branding material.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_08.jpg'
    }, {
      id: 9,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_09.jpg'
    }, {
      id: 10,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_10.jpg'
    }, {
      id: 11,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_11.jpg'
    }, {
      id: 12,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_12.jpg'
    }, {
      id: 13,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_13.jpg'
    }, {
      id: 14,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_14.jpg'
    }, {
      id: 15,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_15.jpg'
    }, {
      id: 16,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_16.jpg'
    }, {
      id: 17,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_17.jpg'
    }, {
      id: 18,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_18.jpg'
    }, {
      id: 19,
      image: '/static/images/case-studies/im-brand-revival/im-brand-revival_19.jpg'
    }]
  }, {
    slug: 'ready_to_rock_tour',
    title: 'Ready to Rock Tour',
    client: 'general electric',
    hero: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock-hero.jpg',
    thumb: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_01.jpg',
    logo: '/static/svg/client-logos/GE.svg',
    desc: '<p>GE Healthcare gains $7 in sales for each $1 spent on PMG marketing tour</p>',
    body: '<p>In 2012 GE and PMG partnered again, this time to launch the Ready to Rock Tour. This tour was made up of one trailer with a double slide-out providing a massive demonstration space for GE’s exciting new technology; Plug and Play BioManufacturing with ReadyToProcess Equipment. The tour traveled to Pharmaceutical companies and research hospitals/institutes to demonstrate machinery capable of achieving a task that until then was only possible in a 40,000 square foot medical manufacturing lab.</p><p>The Plug and Play BioManufacturing with ReadyToProcess Equipment was capable of processing and producing small batch cell cultures for a fraction of the cost, in a fraction of the time, and with a minimal lab space footprint. By splitting the open-space double slide-out trailer into a presentation area and a demonstration area, it was obvious to everyone in attendance that the technology and processes on display were no longer reserved for giant industrial labs.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_07.jpg'
    }]
  }, {
    slug: 'mobile_education',
    title: 'Mobile Education, Therapy and Procedure Training',
    client: 'medtronic',
    hero: '/static/images/case-studies/medtronic-me/medtronic-me-hero.jpg',
    thumb: '/static/images/case-studies/medtronic-me/medtronic-me_01.jpg',
    logo: '/static/svg/client-logos/Medtronic.svg',
    desc: '<p>Over 600 events for therapeutic healthcare supplier Medtronic</p>',
    body: '<p>From 2005 to 2008 PMG partnered with Medtronic again for a tour targeting the education of cardiologists and hospital technicians in the implementation of Pacemaker leads and other Medtronic products. The goal was to educate medical staff on the positive impact of Medtronic\'s products in the battle against heart disease. The first year of the tour would prove so successful that the subsequent years would each see the expansion to an additional trailer on tour. Stepping from one, to two, to finally three concurrent tours is testament to how well experiential marketing can impact sales and aid in customer outreach and training.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_08.jpg'
    }, {
      id: 9,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_09.jpg'
    }, {
      id: 10,
      image: '/static/images/case-studies/medtronic-me/medtronic-me_10.jpg'
    }]
  }, {
    slug: 'acceleration_now_tour',
    title: 'Acceleration Now Tour',
    client: 'ingersoll rand & trane',
    hero: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now-hero.jpg',
    thumb: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_01.jpg',
    logo: '/static/svg/client-logos/Trane.svg',
    desc: '<p>In 2014 Trane and PMG planned and executed an exciting tour launch of their new product lines</p>',
    body: '<p>In 2014 Trane and PMG planned and executed an exciting tour launch of their new product lines centering around marketing efficient and reliable products to building owners and contractors. With three trailers touring together, they visited 70 locations in 39 weeks and made a huge impact at every stop. It was described as “a rolling carnival of Trane products and technology.”</p><p>The centerpiece was a huge double slide-out trailer with an amazing AV experience and several product lines on display. The second trailer housed and transported additional commercial grade chillers and HVAC systems weighing in at several thousand pounds each. Guests were presented with a walk-up podium and ipad guided tour making each piece of equipment the star of a presentation. The final trailer was used for equipment that would otherwise be too large and heavy to attend the tour.</p><p>The three trailers carried large tents to host banquet areas outside of each venue. They also contained 15 interactive kiosks where technical details and fully animated demonstrations of addition pieces in a product line were made available. The most impactful part of the presentation combined a large enclosed tent with a rack of heavy winter parkas. The entire event took place in large parking lots (like the Rosebowl), where temperatures outside reach over 100 degrees. Despite the blistering heat outside, guests were invited to grab a parka and enter the tent for a presentation where the temperature was kept at nearly freezing by a Trane chiller, embodying the experiential marketing philosophy.</p><p>Each event provided drawings, food, and had a party like atmosphere that left potential customers feeling impressed and valued. The entire tour was considered an overwhelming success by everyone involved, and led to an additional tour (of smaller scale) when Ingersoll Rand launched an additional set of products a few years later.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_08.jpg'
    }, {
      id: 9,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_09.jpg'
    }, {
      id: 10,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_10.jpg'
    }, {
      id: 11,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_11.jpg'
    }, {
      id: 12,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_12.jpg'
    }, {
      id: 13,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_13.jpg'
    }, {
      id: 14,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_14.jpg'
    }, {
      id: 15,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_15.jpg'
    }, {
      id: 16,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_16.jpg'
    }, {
      id: 17,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_17.jpg'
    }, {
      id: 18,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_18.jpg'
    }, {
      id: 19,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_19.jpg'
    }, {
      id: 20,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_20.jpg'
    }, {
      id: 21,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_21.jpg'
    }, {
      id: 22,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_22.jpg'
    }, {
      id: 23,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_23.jpg'
    }, {
      id: 24,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_24.jpg'
    }, {
      id: 25,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_25.jpg'
    }, {
      id: 26,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_26.jpg'
    }, {
      id: 27,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_27.jpg'
    }, {
      id: 28,
      image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_28.jpg'
    }]
  }, {
    slug: 'medtronic_software_danek_spinal_tour',
    title: 'Medtronic Sofamor Danek Spinal Tour',
    client: 'medtronic',
    hero: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer-hero.jpg',
    thumb: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_01.jpg',
    logo: '/static/svg/client-logos/Medtronic.svg',
    desc: '<p>Over 600 events for therapeutic healthcare supplier Medtronic</p>',
    body: '<p>From 2002 to 2006 Promotional Management Group was asked to step in and take over the Medtronics Sofamor Danek Spinal Tour. After seeing the professionalism and attention to detail that PMG brought to all of their mobile tours; PMG was given the opportunity to assume management and operation of this two tour program. Each tour consisted of a single 53 foot trailer containing a simulated cadaveric lab used for training. This vehicle was accompanied by a large box truck used to transport cadavers used in the spinal surgery training lab.</p><p>The two tours mirrored each other on opposite sides of the United States visiting Hospitals, Universities and Medical Trade Shows. The sterile surgical environment was ideal for instructing surgeons in a hands on setting. This was PMG’s first experience in cadaveric labs and cemented them as the go-to mobile marketing company for medical education tours.</p>',
    images: [{
      id: 1,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_01.jpg'
    }, {
      id: 2,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_02.jpg'
    }, {
      id: 3,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_03.jpg'
    }, {
      id: 4,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_04.jpg'
    }, {
      id: 5,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_05.jpg'
    }, {
      id: 6,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_06.jpg'
    }, {
      id: 7,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_07.jpg'
    }, {
      id: 8,
      image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_08.jpg'
    }]
  }]
});

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(11);


var _TYPES$CASE$TYPES$FET;




/* harmony default export */ __webpack_exports__["a"] = (_TYPES$CASE$TYPES$FET = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TYPES$CASE$TYPES$FET, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CASE */], function (_ref) {
  var state = _ref.state,
      currentCase = _ref.currentCase;

  console.log('ssdjknskdvnksdv');
  state.currentCase = currentCase;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TYPES$CASE$TYPES$FET, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* FETCH_DATA */], function (_ref2) {
  var state = _ref2.state;

  console.log(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TYPES$CASE$TYPES$FET, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* FETCH_FORM */], function (_ref3) {
  var state = _ref3.state;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get('form').then(function (_ref4) {
    var data = _ref4.data;

    state.form = data.data;
  }, function (error) {
    console.log(error);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TYPES$CASE$TYPES$FET, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* FETCH_SURVEY */], function (_ref5) {
  var state = _ref5.state;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get('survey').then(function (_ref6) {
    var data = _ref6.data;

    state.survey = data.data;
  }, function (error) {
    console.log(error);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TYPES$CASE$TYPES$FET, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* DOWNLOAD_FILE */], function (_ref7, _ref8) {
  var state = _ref7.state;
  var file = _ref8.file;

  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get('file/' + file.hash, { responseType: 'blob' }).then(function (_ref9) {
    var data = _ref9.data;

    var blob = new Blob([data], { type: file.type });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = file.filename;
    link.click();
    state.downloadable = link;
  }, function (error) {
    console.log(error);
  });
}), _TYPES$CASE$TYPES$FET);

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  authUser: function authUser(state) {
    return state.user;
  },

  authToken: function authToken(state) {
    return state.token;
  },

  downloadFile: function downloadFile(state) {
    return state.downloadable;
  },

  showForm: function showForm(state) {
    return state.form;
  },

  beginSurvey: function beginSurvey(state) {
    return state.survey;
  },

  nextQuestion: function nextQuestion(state) {
    return state.survey;
  },

  prevQuestion: function prevQuestion(state) {
    return state.survey;
  },

  finishSurvey: function finishSurvey(state) {
    return state.survey;
  },

  caseStudies: function caseStudies(state) {
    return state.cases;
  },

  currentCase: function currentCase(state) {
    return state.currentCase;
  }

});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(11);


var _CASE$LOGIN$LOGOUT;





/* harmony default export */ __webpack_exports__["a"] = (_CASE$LOGIN$LOGOUT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CASE$LOGIN$LOGOUT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* CASE */], function (state, currentCase) {
  console.log('ttttttt');
  state.currentCase = currentCase;
  __WEBPACK_IMPORTED_MODULE_2_store___default.a.set('currentCase', currentCase);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CASE$LOGIN$LOGOUT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* LOGIN */], function (state, user) {
  state.token = user.api_token;
  state.user = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["omit"])(user, ['api_token']);

  __WEBPACK_IMPORTED_MODULE_2_store___default.a.set('token', state.token);
  __WEBPACK_IMPORTED_MODULE_2_store___default.a.set('user', state.user);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CASE$LOGIN$LOGOUT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* LOGOUT */], function (state) {
  state.token = '';
  state.user = {};

  __WEBPACK_IMPORTED_MODULE_2_store___default.a.remove('token');
  __WEBPACK_IMPORTED_MODULE_2_store___default.a.remove('user');
}), _CASE$LOGIN$LOGOUT);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a55f2aba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(140);
function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a55f2aba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HomeHero__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TourValue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BrandTrust__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValueProposition__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProprietaryEms__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Ems__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CaseStudies__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PmgStory__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Contact__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer__ = __webpack_require__(28);













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'home-hero': __WEBPACK_IMPORTED_MODULE_0__components_HomeHero__["a" /* default */],
    'tour-value': __WEBPACK_IMPORTED_MODULE_1__components_TourValue__["a" /* default */],
    'brand-trust': __WEBPACK_IMPORTED_MODULE_2__components_BrandTrust__["a" /* default */],
    'value-proposition': __WEBPACK_IMPORTED_MODULE_3__components_ValueProposition__["a" /* default */],
    'proprietary-ems': __WEBPACK_IMPORTED_MODULE_4__components_ProprietaryEms__["a" /* default */],
    'ems': __WEBPACK_IMPORTED_MODULE_5__components_Ems__["a" /* default */],
    'case-studies': __WEBPACK_IMPORTED_MODULE_6__components_CaseStudies__["a" /* default */],
    'pmg-story': __WEBPACK_IMPORTED_MODULE_7__components_PmgStory__["a" /* default */],
    'contact': __WEBPACK_IMPORTED_MODULE_8__components_Contact__["a" /* default */],
    'main-footer': __WEBPACK_IMPORTED_MODULE_9__components_Footer__["a" /* default */]
  },
  name: 'home',
  data: function data() {
    return {
      data: {}
    };
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHero_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa03d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeHero_vue__ = __webpack_require__(75);
function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa03d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeHero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(19);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'main-header': __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  name: 'home-hero',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(70);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'main-logo': __WEBPACK_IMPORTED_MODULE_0__components_Logo__["a" /* default */]
  },
  name: 'main-header',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0492303b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__(73);
function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0492303b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-logo',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"main-logo",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 242 72"}},[_c('g',{attrs:{"fill":"none"}},[_c('g',{attrs:{"transform":"translate(-153 -29)translate(153 30)"}},[_c('text',{staticClass:"text"},[_c('tspan',{attrs:{"x":"125","y":"22"}},[_vm._v("\n          Promotional\n        ")]),_vm._v(" "),_c('tspan',{attrs:{"x":"125","y":"42"}},[_vm._v("\n          Management\n        ")]),_vm._v(" "),_c('tspan',{attrs:{"x":"125","y":"62"}},[_vm._v("\n          Group\n        ")])]),_vm._v(" "),_c('path',{attrs:{"d":"M109 0L109 70","stroke":"#FFF"}}),_vm._v(" "),_c('g',{staticClass:"logo"},[_c('path',{attrs:{"d":"M92.9 30.6L71.1 49.4C11.7 47 0 64.2 0 64.2 0 64.2 17.2 41.8 35.5 37 51.4 32.9 92.9 30.6 92.9 30.6ZM60.9 58.4C60.9 58.4 17.8 53.2 0.7 64.7 0.7 64.7 9.6 55 33 53.7 56.5 52.4 66 54 66 54L60.9 58.4Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M27 14.9C26.4 17.3 24.1 17.7 22 17.7L20 17.7 21.3 12.4 23.2 12.4C25.4 12.4 27.5 12.6 27 14.9M83.9 12.3C86.4 12.3 88.6 12.9 89.7 13.6L91.1 7.8C89 7.3 87 7 82.6 7 76.9 7 71.3 9.1 68.2 13.3L69.6 7.4 56.4 7.4 50.6 19.1 50.5 19.1 50.3 7.4 37 7.4 36.1 11.4C35.3 8.3 32 7.4 29.2 7.4L13.8 7.4 8.6 28.8 17.6 28.8 19.1 22.6 25.5 22.6C29 22.6 32.4 21.3 34.4 18.4L31.9 28.8 39.5 28.8 43.6 12 43.8 12 44.2 28.8 51.6 28.8 60.3 12 60.3 12 56.4 28.8 64.4 28.8 65.9 22.7C66.9 27 71.4 29.2 77.3 29.2 81 29.2 83.9 28.8 87.2 28L89.6 17.9 82 17.9 80.6 23.6C80 23.8 79.3 23.8 78.6 23.8 75.1 23.8 74.4 21.2 75.1 18.3 76 14.4 79.4 12.3 83.9 12.3"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h1',[_c('a',{attrs:{"href":"/"}},[_c('main-logo')],1)]),_vm._v(" "),_vm._m(0,false,false)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{staticClass:"tele",attrs:{"href":"tel:704-643-5550"}},[_vm._v("(704) 643-5550")]),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"#contact"}},[_vm._v("contact us")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-hero"},[_c('main-header'),_vm._v(" "),_vm._m(0,false,false)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero__bg"},[_c('img',{attrs:{"src":"/static/images/case-studies/covidien/covidien-hero.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"hero__content"},[_c('h2',[_vm._v("turn key mobile tours")]),_vm._v(" "),_c('p',[_vm._v("driving the brand experience")]),_vm._v(" "),_c('span',{staticClass:"down-arrow"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourValue_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a48baca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourValue_vue__ = __webpack_require__(86);
function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourValue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a48baca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourValue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SectionIntro__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TourInfo__ = __webpack_require__(82);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'section-intro': __WEBPACK_IMPORTED_MODULE_1__components_SectionIntro__["a" /* default */],
    'tour-info': __WEBPACK_IMPORTED_MODULE_2__components_TourInfo__["a" /* default */]
  },
  name: 'tour-value',
  mounted: function mounted() {
    this.$nextTick(this.parallaxImg);
  },
  data: function data() {
    return {};
  },

  methods: {
    parallaxImg: function parallaxImg() {
      var _this = this;

      var floaters = document.querySelectorAll('.ti-img__floater');

      floaters.forEach(function (floater, i) {
        var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();

        tl.set(floaters[i], { y: 100 }).to(floaters[i], 0.5, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Linear"].easeInOut });
        var scene = new _this.$scrollmagic.Scene({
          triggerElement: floater,
          duration: '100%',
          triggerHook: 1,
          reverse: true
        }).setTween(tl);
        _this.$ksvuescr.$emit('addScene', 'parallaxImg', scene);
      });
    }
  },
  destroyed: function destroyed() {
    this.$ksvuescr.$emit('destroy');
  }
});

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'section-intro',
  props: {
    heading: String,
    body: String
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"section-heading"},[_c('div',[_c('span',{staticClass:"notch notch--dark notch--lg notch--bm"}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),(_vm.body)?_c('p',[_vm._v(_vm._s(_vm.body))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourInfo_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5bb99ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourInfo_vue__ = __webpack_require__(85);
function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5bb99ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tour-info',
  props: {
    image: String
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tour-info"},[_c('div',{staticClass:"ti__img"},[_c('div',{staticClass:"ti-img__static"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"ti-img__floater"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"ti__cap"},[_c('div',[_c('span',{staticClass:"notch notch--sm notch--red"}),_vm._v(" "),_c('p',[_vm._t("default",[_vm._v("No data has been entered for this slot.")])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-value"},[_c('section-intro',{attrs:{"heading":"the value of a mobile tour","body":"Do you have products that benefit from live demonstrations? Take your brand on the road. A well-planned, well-executed mobile event can take your brand directly to the audience."}}),_vm._v(" "),_c('tour-info',{attrs:{"image":"/static/images/case-studies/embraer-ej190/embraer-ej190-hero.jpg"}},[_vm._v("\n    An on-site visit allows everyone involved in the purchasing decision to get a hands-on demonstration and sales pitch, without being limited to brochures and first hand accounts of a fraction of the people involved in making the decision.\n  ")]),_vm._v(" "),_c('tour-info',{attrs:{"image":"/static/images/case-studies/is-da-vinci/is-da-vinci_fp.jpg"}},[_vm._v("\n    The difference is equatable to a commercial versus a test drive. Your sales team has to convince a representative from their potential customer to travel in order to experience your product first hand. Typically, this is done at a trade show where your product is never the exclusive topic or demonstration for the day. The sales pitch is then given second hand, and the decision is made without your team's involvement.\n  ")]),_vm._v(" "),_c('tour-info',{attrs:{"image":"/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_01.jpg"}},[_vm._v("\n    A mobile tour changes all of that. Everyone involved in the decision has heard the sales pitch and experienced the product first hand. It's Experimental Marketing. That is the value of a mobile show room. Your product is innovative and extraordinary, surely it would sell itself if only you could get it in front of your customers.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandTrust_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5098f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandTrust_vue__ = __webpack_require__(90);
function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandTrust_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5098f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandTrust_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brand-trust',
  data: function data() {
    return {
      brands: [{
        logo: '../static/svg/client-logos/GE.svg',
        alt: 'Logo 1'
      }, {
        logo: '../static/svg/client-logos/Trane.svg',
        alt: 'Logo 2'
      }, {
        logo: '../static/svg/client-logos/NASA.svg',
        alt: 'Logo 3'
      }, {
        logo: '../static/svg/client-logos/Embraer.svg',
        alt: 'Logo 4'
      }, {
        logo: '../static/svg/client-logos/IntuitiveSurgical.svg',
        alt: 'Logo 5'
      }, {
        logo: '../static/svg/client-logos/Covidien.svg',
        alt: 'Logo 6'
      }, {
        logo: '../static/svg/client-logos/IngersollRand.svg',
        alt: 'Logo 7'
      }, {
        logo: '../static/svg/client-logos/Omnicell.svg',
        alt: 'Logo 8'
      }, {
        logo: '../static/svg/client-logos/IndianMotorcycle.svg',
        alt: 'Logo 9'
      }, {
        logo: '../static/svg/client-logos/Medtronic.svg',
        alt: 'Logo 10'
      }]
    };
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-trust"},[_vm._m(0,false,false),_vm._v(" "),_c('ul',{staticClass:"brand-grid"},_vm._l((_vm.brands),function(brand){return _c('li',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":brand.logo,"alt":brand.alt}})])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"notch notch--light notch--lg notch--bm"}),_vm._v(" "),_c('h2',[_vm._v("brands that trust us")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValueProposition_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f390a30e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueProposition_vue__ = __webpack_require__(95);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValueProposition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f390a30e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueProposition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_TextPlugin__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_TextPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap_TextPlugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SectionIntro__ = __webpack_require__(12);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'section-intro': __WEBPACK_IMPORTED_MODULE_2__components_SectionIntro__["a" /* default */]
  },
  name: 'value-proposition',
  mounted: function mounted() {
    this.$nextTick(this.pinnedSection);
  },
  data: function data() {
    return {};
  },

  methods: {
    pinnedSection: function pinnedSection() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();

      tl.to('.pd__heading', 0.5, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeNone }, 1.5).to('.pd__p-1', 0.5, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeNone }, 1.5).to('.pd__p-2', 0.5, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeNone }, 1.5).set('.pd__heading', { text: 'We believe our greatest asset is leaving our clients with the feeling that the entire process was simple and efficient.' }).set('.pd__p-1', { text: 'The results of the mobile tour are self-evident from the very first event. The turn-key service we provide is second to none. All of our clients have repeat tours, or tour extensions. After measuring the success of the first year of a tour, all of our clients embark on consecutive experiential marketing tours.' }).set('.pd__p-2', { text: 'A great many of our tours become permanent sales tools for our clients, and our best sales tool is when our potential clients see a current client\'s mobile tour and just know that they want that tool for their team.' }).to('.pp__bg--1', 1, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeNone }).fromTo('.pd__heading', 0.7, { y: '+=20' }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut }, '-=0.4').fromTo('.pd__p-1', 0.6, { y: '+=20' }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut }, '-=0.6').fromTo('.pd__p-2', 0.6, { y: '+=20' }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut }, '-=0.6').set('.pd__heading', { autoAlpha: 1 }, '+=2');

      var scene = new this.$scrollmagic.Scene({
        triggerElement: '#pinned',
        duration: '200%',
        triggerHook: 'onLeave',
        reverse: true
      }).setPin('#pinned', { pushfollowers: true }).setTween(tl);

      this.$ksvuescr.$emit('addScene', 'pinnedSection', scene);
    },
    destroyed: function destroyed() {
      this.$ksvuescr.$emit('destroy');
    }
  }
});

/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"value-proposition"},[_c('section-intro',{attrs:{"heading":"a unique value proposition","body":"Your specialty is your product, our specialty is highlighting your product in an extraordinary way. We handle every aspect of your Experiential Marketing Plan to ensure a streamlined and simple process for you and your sales team."}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vp__desktop"},[_c('section',{staticClass:"product-presentation",attrs:{"id":"pinned"}},[_c('div',{staticClass:"pp__bg pp__bg--1"}),_vm._v(" "),_c('div',{staticClass:"pp__bg pp__bg--2"}),_vm._v(" "),_c('div',{staticClass:"presentation__desc"},[_c('div',[_c('h3',{staticClass:"pd__heading"},[_vm._v("You know your product and you have a goal in mind.")]),_vm._v(" "),_c('p',{staticClass:"pd__p-1"},[_vm._v("We help determine the best way to display that product. We then help determine the ideal schedule for the tour. Our EMS system makes planning and tracking events (across your entire sales team) simple. And finally on the day of the event your team shows up to a ready-to-go display.")]),_vm._v(" "),_c('p',{staticClass:"pd__p-2"},[_vm._v("Our goal is to make the entire process from concept to event feel too easy, letting you and your team focus on sales, outreach, training or whatever the goal is for that day.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vp__mobile"},[_c('section',{staticClass:"product-presentation--mobile"},[_c('div',[_c('img',{attrs:{"src":"/static/images/vp__before.jpg","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("You know your product and you have a goal in mind.")]),_vm._v(" "),_c('p',[_vm._v("We help determine the best way to display that product. We then help determine the ideal schedule for the tour. Our EMS system makes planning and tracking events (across your entire sales team) simple. And finally on the day of the event your team shows up to a ready-to-go display.")]),_vm._v(" "),_c('p',[_vm._v("Our goal is to make the entire process from concept to event feel too easy, letting you and your team focus on sales, outreach, training or whatever the goal is for that day.")])]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":"/static/images/vp__after.jpg","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("We believe our greatest asset is leaving our clients with the feeling that the entire process was simple and efficient.")]),_vm._v(" "),_c('p',[_vm._v("The results of the mobile tour are self-evident from the very first event. The turn-key service we provide is second to none. All of our clients have repeat tours, or tour extensions. After measuring the success of the first year of a tour, all of our clients embark on consecutive experiential marketing tours.")]),_vm._v(" "),_c('p',[_vm._v("A great many of our tours become permanent sales tools for our clients, and our best sales tool is when our potential clients see a current client's mobile tour and just know that they want that tool for their team.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProprietaryEms_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e7ff51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProprietaryEms_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProprietaryEms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e7ff51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProprietaryEms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LaptopSVG__ = __webpack_require__(99);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'laptop-svg': __WEBPACK_IMPORTED_MODULE_0__components_LaptopSVG__["a" /* default */]
  },
  name: 'proprietary-ems',
  data: function data() {
    return {
      data: {}
    };
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LaptopSVG_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779211da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaptopSVG_vue__ = __webpack_require__(102);
function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LaptopSVG_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779211da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaptopSVG_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'laptop-svg',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"laptop-svg",attrs:{"viewBox":"0 0 739 925","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Home","transform":"translate(-861.000000, -6105.000000)","fill-rule":"nonzero","fill":"#E65D50"}},[_c('g',{attrs:{"id":"PMG's-proprietary-EMS","transform":"translate(0.000000, 5985.000000)"}},[_c('g',{attrs:{"id":"Macbook-Pro","transform":"translate(861.000000, 120.000000)"}},[_c('path',{attrs:{"d":"M1336.44804,871.428571 C1366.04605,871.428571 1390.03784,847.429615 1390.03784,817.823138 L1390.03784,60.748291 C1390.03784,31.1483463 1366.04907,7.14285714 1336.4659,7.14285714 L1300.74992,7.14285714 L193.579643,7.14285714 L157.863663,7.14285714 C128.280486,7.14285714 104.291718,31.1483463 104.291718,60.748291 L104.291718,817.823138 C104.291718,847.429615 128.283515,871.428571 157.922976,871.428571 L1336.44804,871.428571 Z M1365.03331,871.428571 L1397.31527,871.428571 L1397.31527,878.571429 L97.148684,878.571429 L97.148684,871.428571 L129.282531,871.428571 C110.158741,861.199703 97.148684,841.03147 97.148684,817.823138 L97.148684,60.748291 C97.148684,27.2046086 124.334343,0 157.863663,0 L193.579643,0 L1300.74992,0 L1336.4659,0 C1369.99522,0 1397.18088,27.2046086 1397.18088,60.748291 L1397.18088,817.823138 C1397.18088,841.03147 1384.17082,861.199703 1365.03331,871.428571 Z M1336.46509,924.910531 L1336.46509,925 L157.864473,925 L157.864473,924.910531 L50.599462,924.910531 C50.2106405,924.910531 49.5245797,924.896458 48.5828989,924.855066 C47.0366374,924.7871 45.3194076,924.66517 43.4724285,924.475741 C38.1843029,923.933383 32.8895324,922.955911 27.9086954,921.423383 C19.4329342,918.815522 12.7070424,914.864746 8.45556153,909.196245 C6.57265248,906.685761 5.02363302,903.987536 3.78626599,901.132144 C0.192474971,892.838986 -0.539686954,884.178772 0.335341527,876.47871 C0.454238213,875.432445 0.577118667,874.662413 0.667580222,874.210116 L1.24179709,871.339102 L4.16974082,871.339102 L214.317802,871.339102 L214.317802,878.481959 L4.16974082,878.481959 L7.67190142,875.610945 C7.61950237,875.872934 7.52809191,876.445759 7.43269769,877.285207 C6.68665474,883.850225 7.31795277,891.317392 10.3403971,898.292091 C11.3600303,900.645033 12.6301943,902.857522 14.1699889,904.910531 C17.3679737,909.174405 22.8465262,912.392496 30.0093606,914.59639 C34.4962134,915.976926 39.3453964,916.872138 44.2012242,917.370159 C47.113785,917.668876 49.361481,917.767673 50.599462,917.767673 L235.746904,917.767673 L235.746904,917.857143 L1247.25316,917.857143 L1247.25316,917.767673 L1429.40054,917.767673 C1430.63852,917.767673 1432.88621,917.668876 1435.79878,917.370159 C1440.6546,916.872138 1445.50379,915.976926 1449.99064,914.59639 C1457.15347,912.392496 1462.63203,909.174405 1465.83001,904.910531 C1467.36981,902.857522 1468.63997,900.645033 1469.6596,898.292091 C1472.68205,891.317392 1473.31335,883.850225 1472.5673,877.285207 C1472.47191,876.445759 1472.3805,875.872934 1472.3281,875.610945 L1475.83026,878.481959 L1275.82531,878.481959 L1275.82531,871.339102 L1475.83026,871.339102 L1478.7582,871.339102 L1479.33242,874.210116 C1479.42288,874.662413 1479.54576,875.432445 1479.66466,876.47871 C1480.53969,884.178772 1479.80753,892.838986 1476.21373,901.132144 C1474.97637,903.987536 1473.42735,906.685761 1471.54444,909.196245 C1467.29296,914.864746 1460.56707,918.815522 1452.0913,921.423383 C1447.11047,922.955911 1441.8157,923.933383 1436.52757,924.475741 C1434.68059,924.66517 1432.96336,924.7871 1431.4171,924.855066 C1430.47542,924.896458 1429.78936,924.910531 1429.40054,924.910531 L1336.46509,924.910531 Z M163.5789,825 L165.007507,66.4285714 L1337.89369,67.8571429 L1336.46509,826.428571 L163.5789,825 Z M1336.46509,69.2857143 L166.436114,67.8571429 L165.007507,823.571429 L1335.03648,825 L1336.46509,69.2857143 Z M739.736297,46.4285714 C735.791308,46.4285714 732.593263,43.2306054 732.593263,39.2857143 C732.593263,35.3408232 735.791308,32.1428571 739.736297,32.1428571 C743.681286,32.1428571 746.879331,35.3408232 746.879331,39.2857143 C746.879331,43.2306054 743.681286,46.4285714 739.736297,46.4285714 Z M620.733078,873.571429 L622.161685,873.571429 L872.167875,873.571429 L873.596482,873.571429 L873.596482,875 L873.596482,885.714286 C873.596482,892.433966 868.172543,897.857143 861.425422,897.857143 L632.904138,897.857143 C626.169602,897.857143 620.733078,892.449295 620.733078,885.714286 L620.733078,875 L620.733078,873.571429 Z M872.167875,876.428571 L622.161685,876.428571 L623.590291,875 L623.590291,885.714286 C623.590291,890.867962 627.74424,895 632.904138,895 L861.425422,895 C866.594621,895 870.739269,890.855935 870.739269,885.714286 L870.739269,875 L872.167875,876.428571 Z","id":"Combined-Shape"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"proprietary-ems"},[_c('laptop-svg'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('span',{staticClass:"notch notch--light notch--lg notch--bm"}),_vm._v(" "),_c('h2',[_vm._v("pmg's proprietary ems")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ems-desc"},[_c('h3',[_vm._v("Web-Based Scheduling")]),_vm._v(" "),_c('p',[_vm._v("The PMG Event Management System (EMS™) gives access to all event details. From any web-enabled browser, approved users can see at a glance what is happening with the tour. Depending on the level of authority, users can add events, verify the address and local contact information at the venue and confirm event times. We developed this proprietary application to make multiple tours easier to manage. This unique, proprietary event software is property of Promotional Management Group. The program can be modified to include event reminders, follow up surveys and online invitations for each event.")]),_vm._v(" "),_c('h3',[_vm._v("Easy to Use")]),_vm._v(" "),_c('p',[_vm._v("Clicking on an event title allows users to view specific event information including location, times, delivery instructions, venue contacts and Intuitive Surgical representative contact information. Once logged in, this web-based data is viewable to Promotional Management Group drivers, management and Intuitive Surgical staff. Updated event information is transferred through the EMS and delivered to the driver via email. The driver is in constant communication with Promotional Management Group and Intuitive Surgical to insure a successful event.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ems_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2602ea34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ems_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2602ea34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ems',
  data: function data() {
    return {
      features: [{
        icon: '../static/svg/custom-online-calendars.svg',
        alt: 'Custom online calendars',
        desc: 'Custom online calendars'
      }, {
        icon: '../static/svg/unlimited-users.svg',
        alt: 'Unlimited users with email login and password protection',
        desc: 'Unlimited users with email login and password protection'
      }, {
        icon: '../static/svg/custom-permissions.svg',
        alt: 'Custom permissions for event submission and viewing options per region',
        desc: 'Custom permissions for event submission and viewing options per region'
      }, {
        icon: '../static/svg/vp-directors-permissions.svg',
        alt: 'VP\'s and Directors have special permissions to view multiple schedules (regions)',
        desc: 'VP\'s and Directors have special permissions to view multiple schedules (regions)'
      }, {
        icon: '../static/svg/reporting-capabilities.svg',
        alt: 'Reporting capabilities for all users to view future and past events',
        desc: 'Reporting capabilities for all users to view future and past events'
      }, {
        icon: '../static/svg/seven-day-reminder.svg',
        alt: '7 day reminder notices auto generated and delivered via email to your sales staff',
        desc: '7 day reminder notices auto generated and delivered via email to your sales staff'
      }, {
        icon: '../static/svg/event-requests-date-time-stamped.svg',
        alt: 'All event requests are date and time stamped',
        desc: 'All event requests are date and time stamped'
      }]
    };
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ems"},[_c('section',{staticClass:"ems-feature-set"},[_c('h3',[_vm._v("Event Management System (EMS™)")]),_vm._v(" "),_c('ul',{staticClass:"ems-features"},_vm._l((_vm.features),function(feature){return _c('li',{staticClass:"ems-feature"},[_c('img',{attrs:{"src":feature.icon,"alt":feature.alt}}),_vm._v(" "),_c('span',{staticClass:"notch notch--light notch--lg notch--tm"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(feature.desc))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaseStudies_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2818dc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaseStudies_vue__ = __webpack_require__(129);
function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaseStudies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2818dc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaseStudies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SectionIntro__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'section-intro': __WEBPACK_IMPORTED_MODULE_3__components_SectionIntro__["a" /* default */]
  },
  name: 'case-studies',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['caseStudies'])),
  methods: {
    selectCase: function selectCase(caseStudy) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* CASE */], caseStudy);
      this.$router.push({ name: 'cs', params: { cs: caseStudy.slug } });
    }
  }
});

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-case-studies"},[_c('section-intro',{attrs:{"heading":"case studies"}}),_vm._v(" "),_c('ul',{staticClass:"case-studies"},_vm._l((_vm.caseStudies),function(caseStudy){return _c('li',{on:{"click":function($event){_vm.selectCase(caseStudy)}}},[_c('img',{attrs:{"src":caseStudy.thumb,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"case-study"},[_c('h4',[_vm._v(_vm._s(caseStudy.title))]),_vm._v(" "),_c('div',{staticClass:"cs__desc"},[_c('span'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(caseStudy.desc)}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(caseStudy.client))]),_vm._v(" "),_vm._m(0,true,false)])])}))],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs__indicator"},[_c('img',{attrs:{"src":"/static/svg/plus.svg","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/svg/arrow-right-md.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PmgStory_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4391df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PmgStory_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PmgStory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4391df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PmgStory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'pmg-story',
  props: {
    heading: String,
    body: String
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pmg-story"},[_c('span',{staticClass:"block block--blue"}),_vm._v(" "),_c('span',{staticClass:"block block--blue"}),_vm._v(" "),_c('span',{staticClass:"block block--blue"}),_vm._v(" "),_c('span',{staticClass:"block block--blue"}),_vm._v(" "),_c('span',{staticClass:"block block--red"}),_vm._v(" "),_c('span',{staticClass:"block block--red"}),_vm._v(" "),_c('span',{staticClass:"block block--gray"}),_vm._v(" "),_c('span',{staticClass:"block block--gray"}),_vm._v(" "),_c('span',{staticClass:"block block--gray"}),_vm._v(" "),_c('section',{staticClass:"pmg-story__story"},[_c('h2',[_vm._v("the pmg story")]),_vm._v(" "),_c('p',[_vm._v("PMG was founded by Brad Morris and family after Brad’s experience in the industry showed him that there was a better way to find success with mobile tours. Beginning with tours dedicated to outreach and education PMG found success with brands and companies that wanted to stand out and appreciated the clean and well managed approach that PMG took to building, launching, and operating a mobile tour.")]),_vm._v(" "),_c('p',[_vm._v("After successful tours in industries including auto racing, aeronautics and even space travel: PMG found its niche. The medical industry's demand for hands-on demonstrations, professional appearance and precise scheduling was a perfect fit for PMG. Since PMG’s first medical mobile tours over a decade ago, this has become their industry focus. PMG is chosen time and time again as the go-to medical tour resource by Fortune 500 companies. They value our uniquely professional image and managerial style. Our staff, equipment, and processes are all uniquely professional and skilled. Companies with products and clients that value quality (like those in the medical equipment industry) come to us when they need a mobile tour, and they come back consistently to repeat the success of their first tour.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact',
  data: function data() {
    return {
      data: {
        form: {
          code: 'contact-form-1-jd4kBz',
          fields: {
            first_name: '',
            last_name: '',
            email: '',
            phone: ''
          }
        }
      }
    };
  },

  methods: {
    save: function save() {
      this.$http.patch('form/' + this.data.form.code, this.data).then(function (_ref) {
        var data = _ref.data;

        console.log(data);
        alert(data.message);
      }, function (_ref2) {
        var data = _ref2.data;

        data && alert(data.message);
      });
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-contact",attrs:{"id":"contact"}},[_c('section',{staticClass:"contact-us"},[_vm._m(0,false,false),_vm._v(" "),_c('form',{staticClass:"contact-form",on:{"submit":function($event){$event.preventDefault();_vm.save($event)}}},[_c('section',{staticClass:"cf__controls"},[_c('div',{staticClass:"cf__control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.form.fields.first_name),expression:"data.form.fields.first_name"}],attrs:{"type":"text","placeholder":"First Name"},domProps:{"value":(_vm.data.form.fields.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.form.fields, "first_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cf__control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.form.fields.last_name),expression:"data.form.fields.last_name"}],attrs:{"type":"text","placeholder":"Last Name"},domProps:{"value":(_vm.data.form.fields.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.form.fields, "last_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cf__control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.form.fields.phone),expression:"data.form.fields.phone"}],attrs:{"type":"text","placeholder":"Phone"},domProps:{"value":(_vm.data.form.fields.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.form.fields, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cf__control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.form.fields.email),expression:"data.form.fields.email"}],attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.data.form.fields.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.form.fields, "email", $event.target.value)}}})])]),_vm._v(" "),_vm._m(1,false,false)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-intro"},[_c('span',{staticClass:"notch notch--lg notch--dark notch--bm"}),_vm._v(" "),_c('h2',[_vm._v("contact us")]),_vm._v(" "),_c('p',[_vm._v("We are happy to assist you with your project no matter what stage it is in. Please feel free to contact us for anything from a budget consultation to a request for proposal. We will answer any questions you might have about mobile touring or experiential marketing. Call us at 704-643-5550, or submit your info below to schedule a call or meeting.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cf__control--btn"},[_c('button',{staticClass:"cf__button",attrs:{"type":"submit"}},[_c('span',[_vm._v("submit")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-footer',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('p',[_vm._v("© 2017 pmg marketing tours, charlotte north carolina. all rights reserved.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('home-hero'),_vm._v(" "),_c('tour-value'),_vm._v(" "),_c('brand-trust'),_vm._v(" "),_c('value-proposition'),_vm._v(" "),_c('proprietary-ems'),_vm._v(" "),_c('ems'),_vm._v(" "),_c('case-studies'),_vm._v(" "),_c('pmg-story'),_vm._v(" "),_c('contact'),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaseStudy_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e212ae9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaseStudy_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaseStudy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e212ae9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaseStudy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CsHero__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CsInternal__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CsGallery__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Contact__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer__ = __webpack_require__(28);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'cs-hero': __WEBPACK_IMPORTED_MODULE_2__components_CsHero__["a" /* default */],
    'cs-internal': __WEBPACK_IMPORTED_MODULE_3__components_CsInternal__["a" /* default */],
    'cs-gallery': __WEBPACK_IMPORTED_MODULE_4__components_CsGallery__["a" /* default */],
    'contact': __WEBPACK_IMPORTED_MODULE_5__components_Contact__["a" /* default */],
    'main-footer': __WEBPACK_IMPORTED_MODULE_6__components_Footer__["a" /* default */]
  },
  name: 'cs',
  data: function data() {
    return {
      isActive: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['currentCase'])),
  methods: {
    lightbox: function lightbox(id) {
      this.isActive = id;
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CsHero_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_556b3dc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CsHero_vue__ = __webpack_require__(147);
function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CsHero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_556b3dc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CsHero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(19);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'main-header': __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  name: 'cs-hero',
  props: {
    image: String,
    alt: String
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-hero"},[_c('main-header'),_vm._v(" "),_c('section',{staticClass:"cs-hero__bg"},[_vm._t("hero-image")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CsInternal_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dccd9434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CsInternal_vue__ = __webpack_require__(151);
function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CsInternal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dccd9434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CsInternal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cs-internal',
  data: function data() {
    return {};
  },

  methods: {
    lightbox: function lightbox(id) {
      this.isActive = id;
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-internal"},[_c('span'),_vm._v(" "),_c('header',{staticClass:"cs__title"},[_c('div',[_vm._t("title",[_vm._v("Default title")]),_vm._v(" "),_vm._t("client",[_vm._v("Default client")])],2)]),_vm._v(" "),_c('div',{staticClass:"cs__logo"},[_vm._t("logo",[_c('img',{attrs:{"src":"https://placehold.it/100x100?text=N/A","alt":"No image found."}})])],2),_vm._v(" "),_c('article',{staticClass:"s-cs__desc"},[_c('span',{staticClass:"notch notch--sm notch--red"}),_vm._v(" "),_c('div',[_vm._t("desc")],2)]),_vm._v(" "),_c('section',{staticClass:"s-gallery"},[_c('h4',[_vm._v("Gallery")]),_vm._v(" "),_c('ul',{staticClass:"cs__gallery"},_vm._l((_vm.images),function(image){return _c('li',{key:image.id,on:{"click":function($event){_vm.lightbox(image.id)}}},[_vm._t("image",[_c('img',{attrs:{"src":"https://placehold.it/500x250?text=N/A"}})]),_vm._v(" "),_vm._m(0,true,false),_vm._v(" "),(_vm.isActive === image.id)?_c('div',{staticClass:"cs__lightbox-bg",on:{"click":function($event){$event.stopPropagation();_vm.isActive = false}}},[_c('div',{staticClass:"cs__lightbox"},[_vm._t("image",[_c('img',{attrs:{"src":"https://placehold.it/500x250?text=N/A"},on:{"click":function($event){$event.stopPropagation();_vm.isActive = false}}})])],2)]):_vm._e()],2)}))]),_vm._v(" "),_c('span'),_vm._v(" "),_c('aside')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs__gallery-img"},[_c('div',[_c('img',{attrs:{"src":"/static/svg/eye.svg","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CsGallery_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efa03dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CsGallery_vue__ = __webpack_require__(155);
function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CsGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efa03dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CsGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cs-gallery',
  data: function data() {
    return {
      isActive: false,
      images: [{
        id: 1,
        image: 'https://fillmurray.com/300/400'
      }, {
        id: 2,
        image: 'https://fillmurray.com/400/400'
      }, {
        id: 3,
        image: 'https://fillmurray.com/500/400'
      }, {
        id: 4,
        image: 'https://fillmurray.com/600/400'
      }, {
        id: 5,
        image: 'https://fillmurray.com/700/400'
      }, {
        id: 6,
        image: 'https://fillmurray.com/800/400'
      }, {
        id: 7,
        image: 'https://fillmurray.com/500/400'
      }, {
        id: 8,
        image: 'https://fillmurray.com/500/400'
      }, {
        id: 9,
        image: 'https://fillmurray.com/500/400'
      }, {
        id: 10,
        image: 'https://fillmurray.com/500/400'
      }, {
        id: 11,
        image: 'https://fillmurray.com/500/400'
      }, {
        id: 12,
        image: 'https://fillmurray.com/500/400'
      }]
    };
  },

  methods: {
    lightbox: function lightbox(id) {
      this.isActive = id;
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"s-gallery"},[_c('h4',[_vm._v("Gallery")]),_vm._v(" "),_c('ul',{staticClass:"cs__gallery"},_vm._l((_vm.images),function(image){return _c('li',{key:image.id,on:{"click":function($event){_vm.lightbox(image.id)}}},[_c('img',{attrs:{"src":image.image,"alt":['Gallery Image ' + image.id]}}),_vm._v(" "),_vm._m(0,true,false),_vm._v(" "),(_vm.isActive === image.id)?_c('div',{staticClass:"cs__lightbox-bg",on:{"click":function($event){$event.stopPropagation();_vm.isActive = false}}},[_c('div',{staticClass:"cs__lightbox"},[_c('img',{attrs:{"src":image.image,"alt":['Gallery Image ' + image.id]},on:{"click":function($event){$event.stopPropagation();_vm.isActive = false}}})])]):_vm._e()])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs__gallery-img"},[_c('div',[_c('img',{attrs:{"src":"/static/svg/eye.svg","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-page"},[_c('cs-hero',[_c('img',{attrs:{"slot":"hero-image","src":_vm.currentCase.hero,"alt":_vm.currentCase.title},slot:"hero-image"})]),_vm._v(" "),_c('div',{staticClass:"cs-internal"},[_c('span'),_vm._v(" "),_c('header',{staticClass:"cs__title"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.currentCase.title))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.currentCase.client))])])]),_vm._v(" "),_c('div',{staticClass:"cs__logo"},[_c('img',{attrs:{"src":_vm.currentCase.logo}})]),_vm._v(" "),_c('article',{staticClass:"s-cs__desc"},[_c('span',{staticClass:"notch notch--sm notch--red"}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentCase.body)}})]),_vm._v(" "),_c('section',{staticClass:"s-gallery"},[_c('h4',[_vm._v("Gallery")]),_vm._v(" "),_c('ul',{staticClass:"cs__gallery"},_vm._l((_vm.currentCase.images),function(image){return _c('li',{key:image.id,on:{"click":function($event){_vm.lightbox(image.id)}}},[_c('img',{attrs:{"src":image.image}}),_vm._v(" "),_vm._m(0,true,false),_vm._v(" "),(_vm.isActive === image.id)?_c('div',{staticClass:"cs__lightbox-bg",on:{"click":function($event){$event.stopPropagation();_vm.isActive = false}}},[_c('div',{staticClass:"cs__lightbox"},[_c('img',{attrs:{"src":image.image},on:{"click":function($event){$event.stopPropagation();_vm.isActive = false}}})])]):_vm._e()])}))]),_vm._v(" "),_c('span'),_vm._v(" "),_c('aside')]),_vm._v(" "),_c('contact'),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs__gallery-img"},[_c('div',[_c('img',{attrs:{"src":"/static/svg/eye.svg","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665ef514_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(161);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665ef514_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"home"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"cs"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[29]);


// WEBPACK FOOTER //
// static/js/app.e5392fac5cbdd2c5f0b9.js